// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editable-title[data-v-26dd485c]{margin:2em 0 1em 0;display:flex;align-items:center}.editable-title .title[data-v-26dd485c],.editable-title i[data-v-26dd485c]{padding-bottom:3px}.editable-title .title[data-v-26dd485c],.editable-title input[data-v-26dd485c]{font-size:1.5em;font-weight:700;color:var(--primary)}.editable-title input[data-v-26dd485c]{border:none;outline:none;border-bottom:1px solid #bababa}.editable-title i[data-v-26dd485c]{cursor:pointer;margin-left:.5em}", ""]);
// Exports
module.exports = exports;
